import React, {Component} from 'react';
import {LoadScriptNext} from '@react-google-maps/api';
import PropTypes from 'prop-types';

import styles from './GMap.module.scss';

import {Map} from './components';

export class GMap extends Component {
  render() {
    const {markers, options, devMode, gKey} = this.props;

    if (!devMode && gKey && gKey.length !== 39)
      return 'Api key has incorrect length';

    return (
      <div id="GMap" className={styles.map} ref={n => (this.map = n)}>
        <LoadScriptNext language="en" googleMapsApiKey={gKey}>
          <Map markers={markers} options={options} />
        </LoadScriptNext>
      </div>
    );
  }
}

GMap.propTypes = {
  options: PropTypes.object,
  markers: PropTypes.arrayOf(PropTypes.object),
  devMode: PropTypes.bool,
  gKey: PropTypes.string,
};

GMap.defaultProps = {
  options: {},
  markers: [],
  devMode: false,
  gKey: '',
};
